import React from 'react';

import StickyPageHeader from '../components/common/StickyPageHeader';
import RatesUpload from '../components/RatesUpload';
import { useSelectedCarrier, useShipTypes } from '../hooks/apiHooks';
import Layout from '../layout';

const CarrierUploadPage = ({ routes }) => {
  const { selectedCarrier } = useSelectedCarrier();
  const { allShipTypes } = useShipTypes();

  return (
    <Layout
      showCarriersNavigation
      disableLoading={false}
      menuIndex={0}
      routes={routes}
    >
      <StickyPageHeader subtitle={selectedCarrier?.name} title="Upload Rates" />

      {selectedCarrier && (
        <RatesUpload
          selectedCarrier={selectedCarrier}
          shipTypes={allShipTypes}
        />
      )}
    </Layout>
  );
};

export default CarrierUploadPage;
